import { render, staticRenderFns } from "./Ph2SupplementContent.vue?vue&type=template&id=4f5b6194&"
import script from "./Ph2SupplementContent.vue?vue&type=script&lang=js&"
export * from "./Ph2SupplementContent.vue?vue&type=script&lang=js&"
import style0 from "./Ph2SupplementContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports